import {
  type PositionCode,
  type remotePositionCodeList,
  transformRemotePositionCodeListToPositionCodeList,
} from '@/types/info'
import apiClient from '@/utils/http'

export default class PositionCodeService {
  static data: PositionCode[] = PositionCodeService.getLocalStore() ?? []

  static async reqPositionCodeList(batchId?: number) {
    if (!batchId) {
      return []
    }
    const rawData = (await apiClient.get(
      `/batch/${batchId}/position`,
    )) as remotePositionCodeList
    const data = transformRemotePositionCodeListToPositionCodeList(rawData)
    PositionCodeService.data = data
    return PositionCodeService.storeInLocal()
  }

  static storeInLocal() {
    localStorage.setItem(
      'positionCodeList',
      JSON.stringify(PositionCodeService.data),
    )
    return PositionCodeService.data
  }

  static getLocalStore() {
    const positionCodeList = localStorage.getItem('positionCodeList')
    if (positionCodeList) {
      PositionCodeService.data = JSON.parse(positionCodeList)
    }
    return PositionCodeService.data
  }

  static getPositionCode(positionCodeId: PositionCode['id']) {
    return PositionCodeService.data.find((item) => item.id === positionCodeId)
  }

  static getPositionCodeName(positionCodeId: PositionCode['id']) {
    return PositionCodeService.getPositionCode(positionCodeId)?.name
  }

  // static getPositionCodeHasInventory(positionCodeId: PositionCode['id']) {
  //   return (
  //     PositionCodeService.data?.find(
  //       (positionCode) => positionCode.id === positionCodeId,
  //     )?.hasInventory ?? 0
  //   )
  // }

  static async reqPositionCodeHasInventory(
    positionCodeIdList: PositionCode['id'][],
    batchId: number,
  ) {
    const validPositionCodeIdList = positionCodeIdList.filter(
      (id) => id !== undefined,
    ) as PositionCode['id'][]
    if (!validPositionCodeIdList.length) {
      return []
    }
    const data = (await apiClient.get(
      `/position/inventory?${validPositionCodeIdList.map((id) => `ids=${id}`).join('&')}&batchId=${batchId}`,
    )) as hasInventoryList
    return data ?? []
  }
}
export type hasInventoryList = {
  id: number
  hasInventory: 1 | 0
}[]
